import { render, staticRenderFns } from "./WelfareMonitoring.vue?vue&type=template&id=80099162&"
import script from "./WelfareMonitoring.vue?vue&type=script&lang=js&"
export * from "./WelfareMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports